module.exports = __webpack_public_path__ + "img/favicon_mayo_3.00c67942.png";